var Ajaxinate = function ajaxinateConstructor(config) {
  var settings = config || {};

  // Set offset dynamically based on screen size
  var dynamicOffset = window.innerWidth < 768 ? 800 : 1600;

  var defaultSettings = {
    pagination: '#AjaxinatePagination',
    method: 'scroll',
    container: '#AjaxinateLoop',
    offset: dynamicOffset,
    loadingText: '<div class="seCollectionLoader"><div class="seSpinner lg"></div></div>',
    callback: null
  };

  this.settings = Object.assign(defaultSettings, settings);

  this.addObserver = this.addObserver.bind(this);
  this.addClickListener = this.addClickListener.bind(this);
  this.stopMultipleClicks = this.stopMultipleClicks.bind(this);
  this.destroy = this.destroy.bind(this);
  this.removeObserver = this.removeObserver.bind(this);

  this.containerElement = document.querySelector(this.settings.container);
  this.paginationElement = document.querySelector(this.settings.pagination);

  this.initialize();
};

Ajaxinate.prototype.initialize = function () {
  if (this.containerElement) {
    var initializers = {
      click: this.addClickListener,
      scroll: this.addObserver
    };
    initializers[this.settings.method]();
  }
};

Ajaxinate.prototype.addObserver = function () {
  if (!this.paginationElement) return;

  this._observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        this.nextPageLinkElement = this.paginationElement.querySelector('a');
        if (this.nextPageLinkElement) {
          this.nextPageLinkElement.innerHTML = this.settings.loadingText;
          this.nextPageUrl = this.nextPageLinkElement.href;

          // Stop observing to prevent multiple triggers
          this._observer.unobserve(this.paginationElement);

          this.loadMore();
        }
      }
    });
  }, {
    rootMargin: `${this.settings.offset}px`,
    threshold: 0.1
  });

  this._observer.observe(this.paginationElement);
};

Ajaxinate.prototype.addClickListener = function () {
  if (this.paginationElement) {
    this.nextPageLinkElement = this.paginationElement.querySelector('a');
    this.clickActive = true;
    if (this.nextPageLinkElement !== null) {
      this.nextPageLinkElement.addEventListener('click', this.stopMultipleClicks);
    }
  }
};

Ajaxinate.prototype.stopMultipleClicks = function (event) {
  event.preventDefault();
  if (this.clickActive) {
    this.nextPageLinkElement.innerHTML = this.settings.loadingText;
    this.nextPageUrl = this.nextPageLinkElement.href;
    this.clickActive = false;
    this.loadMore();
  }
};

Ajaxinate.prototype.loadMore = function () {
  this.request = new XMLHttpRequest();

  this.request.onreadystatechange = function () {
    if (this.request.readyState === 4 && this.request.status === 200) {
      if (!this.request.responseXML) return;

      var newContainer = this.request.responseXML.querySelectorAll(this.settings.container)[0];
      var newPagination = this.request.responseXML.querySelectorAll(this.settings.pagination)[0];

      // Add animation classes to lazy-loaded images
      newContainer.querySelectorAll("img[loading='lazy']")?.forEach(img => {
        img.classList.add("aos-init", "aos-animate");
      });

      this.containerElement.insertAdjacentHTML('beforeend', newContainer.innerHTML);

      // Restart MagicZoom if used
      if (typeof MagicZoom !== 'undefined') {
        MagicZoom.start();
      }

      // Refresh AOS animations if present
      if (typeof AOS !== 'undefined' && typeof AOS.refresh === 'function') {
        AOS.refresh();
      }

      if (!newPagination) {
        var infiniteNext = document.querySelector(".infinite_next");
        if (infiniteNext) {
          infiniteNext.style.display = "none";
        }
        return;
      }

      this.paginationElement.innerHTML = newPagination.innerHTML;

      if (this.settings.callback && typeof this.settings.callback === 'function') {
        this.settings.callback(this.request.responseXML);
      }

      // Re-initialize observer on the new pagination
      this.paginationElement = document.querySelector(this.settings.pagination);
      this.initialize();
    }
  }.bind(this);

  this.request.open('GET', this.nextPageUrl);
  this.request.responseType = 'document';
  this.request.send();
};

Ajaxinate.prototype.removeClickListener = function () {
  if (this.nextPageLinkElement) {
    this.nextPageLinkElement.removeEventListener('click', this.stopMultipleClicks);
  }
};

Ajaxinate.prototype.removeObserver = function () {
  if (this._observer) {
    this._observer.disconnect();
    this._observer = null;
  }
};

Ajaxinate.prototype.destroy = function () {
  var destroyers = {
    click: this.removeClickListener,
    scroll: this.removeObserver
  };
  destroyers[this.settings.method]();
  return this;
};
